<style scoped lang="sass">
.bar
  display: flex
  justify-content: center
  align-items: center
  background-color: #1e3f67
  height: 40px
  img
    height: 20px
.hero
  display: flex
  flex-direction: column
  align-items: center
  background-image: url(../../assets/images/landing-hero.jpg)
  background-size: cover
  background-repeat: no-repeat
  background-position: center
  color: white
  padding: 2rem 0rem 0rem 0rem
  .hero-text
    width: 20rem
    .title
      font-size: 1.6rem
      line-height: 1.8rem
      font-weight: 600
      text-shadow: 0.2rem 0.2rem 0.4rem black
    .subtitle
      padding-top: 0.4rem
      font-size: 1rem
      line-height: 1.2rem
      text-shadow: 0.2rem 0.2rem 0.4rem black
  .stores
    text-align: center
    margin-top: 1rem
    img
      height: 40px
      margin: 0.5rem
  .mobile-phones
    display: flex
    align-items: flex-end
    justify-content: center
    margin-top: 2rem
    img
      width: 260px
      height: 230px
.mobile-app
  padding: 1rem 1rem 0rem 1rem
  text-align: center
  background-image: url(../../assets/images/course-background.jpg)
  background-size: cover
  background-repeat: no-repeat
  background-position: center
  color: white
  .title
    font-size: 1.4rem
    line-height: 1.8rem
    font-weight: 600
    padding-bottom: 0.5rem
  .subtitle
    padding-bottom: 0.5rem
    font-size: 1rem
    line-height: 1.2rem
.bottom
  padding: 0.5rem 1rem
  text-align: center
  font-size: 0.7rem
</style>
<template>
  <div class="page">
    <div class="bar">
      <img src="../../assets/images/logo-small.png">
    </div>
    <div class="hero">
      <div class="hero-text">
        <div>
          <div class="title">Run your own</div>
          <div class="title">Fantasy golf pools</div>
        </div>
        <div class="subtitle">
          Easily create custom pools for real PGA Tour events.
        </div>
      </div>
      <div class="stores">
        <a target="_blank" href="https://itunes.apple.com/us/app/pinhigh-fantasy-golf/id1091329116">
          <img src="../../assets/images/apple-store.png">
        </a>
        <a target="_blank" href="https://play.google.com/store/apps/details?id=co.pinhigh">
          <img src="../../assets/images/android-store.png">
        </a>
      </div>
      <div class="mobile-phones"><img src="../../assets/images/mobile-phones.png" alt="Mobile phones" /></div>
    </div>
    <div class="bottom">
      ©{{thisYear}} PinHigh. All rights reserved. Made in SoCal. We’re big fans of the PGA Tour, but there’s no affilation.
    </div>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  name: 'landing',
  computed: {
    thisYear() { return moment().format('YYYY') }
  }
}
</script>
